import { createFileRoute, notFound } from '@tanstack/react-router';

import { communicationSettingSearch, loadCommunicationSettingMessages } from '@/modules/communication-setting/public';
import { lazyScreen } from '@/shared/screen';

// /dev/regua-comunicacao (só dev): a tela real da Régua de comunicação sobre o MSW, sem login (X02).
// Em produção responde 404 e o chunk nem é pedido.
export const Route = createFileRoute('/dev/regua-comunicacao/')({
  validateSearch: communicationSettingSearch,
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  loader: () => loadCommunicationSettingMessages(),
  component: import.meta.env.DEV ? lazyScreen(() => import('./-page'), 'CommunicationSettingDevPage') : () => null,
});
